import React, { useEffect, useContext } from "react";
import Cookies from "universal-cookie";

import { ThemeConstants, ThemeContext, AuthContext } from "../App";

export const Redirecting = () => {
  const themeConfig = useContext(ThemeContext);
  const themeConstants = useContext(ThemeConstants);
  const authContext = useContext(AuthContext);

  const cookies = new Cookies();

  //Handles post login redirection
  useEffect(() => {
    const redirectedFromCognito = cookies.get(
      "amplify-redirected-from-hosted-ui"
    );
    const lastVisitedURL = "/";

    if (authContext.isAuthenticated && redirectedFromCognito === true) {
      cookies.remove("amplify-redirected-from-hosted-ui", {
        domain: themeConstants.COOKIE_STORAGE_DOMAIN,
        path: "/",
      });
      window.location.href = lastVisitedURL;
    }
  }, [authContext.isAuthenticated]);

  return (
    <div
      className={`flex flex-col items-center justify-center max-w-lg p-8 my-20 mx-auto rounded shadow-md ${themeConfig.redirectingTextColor} ${themeConfig.redirectingBorder}`}
    >
      <img src={themeConfig.logo} alt="brand logo" className="w-44 mb-2" />
      <p className="my-4 mx-auto text-center">
        <i className="fa fa-sync fa-spin text-4xl"></i>
      </p>
      <p className="text-xl mb-3">Logging In</p>
      <p className="text-center text-base">
        Please wait while you are logged in...
      </p>
    </div>
  );
};

export default Redirecting;
